import { useTranslation } from 'react-i18next';
import { Box } from '@chakra-ui/react';

export const TopListingBadge = () => {
  const { t } = useTranslation();
  return (
    <Box
      position="absolute"
      top={0}
      right={4}
      transform="translateY(-50%)"
      bg="primary.500"
      color="white"
      fontSize="xs"
      fontWeight="semibold"
      borderRadius="default"
      px={2}
      py={1.5}
      lineHeight="1"
      zIndex={100}
    >
      {t('selectableCard.recommended')}
    </Box>
  );
};
